import { Stack } from "components/icons/generated";
import useStackSearchForNavigation from "shared/Stack/useSearchForNavigation";

import CommandPaletteEntitySearch from "./EntitySearch";

const useSearchHook = ({ query }: { query: string }) => {
  return useStackSearchForNavigation({ query });
};

const CommandPaletteSubListViewStacksSearch = () => (
  <CommandPaletteEntitySearch
    useSearchHook={useSearchHook}
    icon={Stack}
    pathPrefix="/stack/"
    entityName="stacks"
  />
);

export default CommandPaletteSubListViewStacksSearch;
